export default [
  {
    id: '0ff5bcf1-d281-4221-ba78-891796074b1e',
    path: 'data-validation-report',
    name: 'data-validation-report',
    meta: { title: '数据校验报表' },
    children: [
      {
        id: '4b44198a-8c44-4107-bc75-6237e430ee1f',
        path: 'document-file',
        name: 'document-file',
        component: () => {
          return import('../views/dataValidationReport/documentFile')
        },
        meta: {
          title: '文档文件完整性校验报表',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'dc57c5ab-1572-4c5a-9bab-359083a5b7f9',
        path: 'empty-file-category',
        name: 'empty-file-category',
        component: () => {
          return import('../views/dataValidationReport/emptyFileCategory')
        },
        meta: {
          title: '空文档目录校验报表',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '1aa43d5f-ab81-46cd-98eb-d10eee6e5a56',
        path: 'comprehensive-statistics',
        name: 'comprehensive-statistics',
        component: () => {
          return import('../views/dataValidationReport/comprehensiveStatistics')
        },
        meta: {
          title: '数据校验综合统计',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '757c5013-2627-4df4-9fa2-b81ae8780142',
        path: 'object-compliance-report',
        name: 'object-compliance-report',
        component: () => {
          return import('../views/dataValidationReport/objectComplianceReport')
        },
        meta: {
          title: '对象合规性校验报表',
          keepAlive: false,
          operations: {
            rulesSetting: {
              id: 0,
              name: 'rulesSetting',
              desc: '规则设置',
              access: true,
            },
            export: {
              id: 1,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: '51907f51-9957-43a6-b763-ff1ad64d5683',
        path: 'document-compliance-report',
        name: 'document-compliance-report',
        component: () => {
          return import('../views/dataValidationReport/documentComplianceReport')
        },
        meta: {
          title: '文档合规性校验报表',
          keepAlive: false,
          operations: {
            rulesSetting: {
              id: 0,
              name: 'rulesSetting',
              desc: '规则设置',
              access: true,
            },
            export: {
              id: 1,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: 'c84e99d0-63e2-45e5-b7d0-e8b9915d7bf9',
        path: 'object-attribute-report',
        name: 'object-attribute-report',
        component: () => {
          return import('../views/dataValidationReport/objectAttributeReport')
        },
        meta: {
          title: '对象属性完整性报表',
          keepAlive: false,
          operations: {
            export: {
              id: 0,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: '4a2f5220-1337-4dff-8c2d-cc14c0f2fbe2',
        path: 'rule-settings',
        name: 'rule-settings',
        component: () => {
          return import('../views/dataValidationReport/ruleSettings')
        },
        meta: {
          title: '规则设置',
          keepAlive: false,
          hidden: true,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '添加',
              access: true,
            },
            delete: {
              id: 0,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
